// @flow
export const CHANGE_MOTION_SENSOR_SELECTED_DAY = 'hive/motion-sensor/CHANGE_MOTION_SENSOR_SELECTED_DAY';
export const CHANGE_MOTION_SENSOR_ZOOM_LEVEL = 'hive/motion-sensor/CHANGE_MOTION_SENSOR_ZOOM_LEVEL';
export const CHANGE_EVENTS_CURRENT_DAY = 'hive/motion-sensor/CHANGE_EVENTS_CURRENT_DAY';
export const GET_MOTION_SENSOR_EVENTS = 'hive/motion-sensor/GET_MOTION_SENSOR_EVENTS';
export const LOAD_MOTION_SENSOR_PAGE = 'hive/motion-sensor/LOAD_MOTION_SENSOR_PAGE';
export const MOTION_SENSOR_PAGE_READY = 'hive/motion-sensor/MOTION_SENSOR_PAGE_READY';
export const RECEIVE_MOTION_SENSOR_EVENTS = 'hive/motion-sensor/RECEIVE_MOTION_SENSOR_EVENTS';
export const UNLOAD_MOTION_SENSOR_PAGE = 'hive/motion-sensor/UNLOAD_MOTION_SENSOR_PAGE';



// WEBPACK FOOTER //
// ./src/core/state/products/motion-sensor/constants.js